import { v4 as uuidv4 } from 'uuid';

import member5 from './Untitled2.png';
import member6 from './Untitled.png';

const teamData = [
    {
        id: uuidv4(),
        img: member6,
        name: 'Mr. Thomas A. Klaas',
        position: 'Marketing Director & Technical Services',
        fbLink: '#',
        twitterLink: '#',
        behanceLink: '#',
        youtubeLink: '#',
        bio: "As the Director of Marketing & Technical Services, Mr. Thomas A. Klaas plays a key role in driving innovation and customer engagement at Testfabrics A graduate of the Georgia Institute of Technology, he brings extensive expertise in marketing and technical solutions to the textile industry."
    },

    {
        id: uuidv4(),
        img: member6,
        name: 'Mr. M. Abid Hafeez',
        position: 'Technical Director and Equipment Sales Manager ',
        fbLink: '#',
        twitterLink: '#',
        behanceLink: '#',
        youtubeLink: '#',
        bio: "Serving as the Technical Director and Equipment Sales Manager, Mr. M. Abid Hafeez specializes in polymer and textile chemistry. A graduate of Clemson University, SC, he leads the technical team, ensuring excellence in equipment sales and fabric solutions."
    },

    {
        id: uuidv4(),
        img: member6,
        name: 'Mr. Shawn Meeks ',
        position: 'Laboratory Manager, Dyer & Colorist, Technical Service Associate',
        fbLink: '#',
        twitterLink: '#',
        behanceLink: '#',
        youtubeLink: '#',
        bio: "Mr. Shawn Meeks is the Laboratory Manager, Dyer & Colorist, and Technical Service Associate at Testfabrics. With a degree in Textile Chemistry from North Carolina State University, he oversees laboratory operations and provides expert insights into dyeing and color technology."
    },

    {
        id: uuidv4(),
        img: member6,
        name: 'KILMON L. LIMONA',
        position: 'Support Engineer',
        fbLink: '#',
        twitterLink: '#',
        behanceLink: '#',
        youtubeLink: '#',
        bio: "As the Accounts Manager, Mr. Jeremy Klaas ensures smooth financial operations at Testfabrics A graduate of Lycoming College, Williamsport, PA, he manages the company’s financial transactions and client accounts with precision."
    },

    {
        id: uuidv4(),
        img: member6,
        name: 'Mr. Jeremy Klaas',
        position: 'Accounts Manager',
        fbLink: '#',
        twitterLink: '#',
        behanceLink: '#',
        youtubeLink: '#',
        bio: "Ms. Miranda Klaas serves as a Quality Assurance Laboratory Technician and Customer Service Coordinator, ensuring product quality and excellent customer service. She holds a degree from Wells College, Aurora, NY, bringing a strong academic background to her role."
    },

    {
        id: uuidv4(),
        img: member5,
        name: 'Ms. Miranda Klaas',
        position: 'Quality Assurance Laboratory Technician & Customer Service Coordinator',
        fbLink: '#',
        twitterLink: '#',
        behanceLink: '#',
        youtubeLink: '#',
        bio: "A Quality Assurance Laboratory Technician and Customer Service Coordinator, Ms. Charly Klaas plays a vital role in maintaining high product standards and ensuring customer satisfaction."
    },

    {
        id: uuidv4(),
        img: member5,
        name: 'Ms. Normandy Klaas',
        position: 'Sales & Marketing Coordinato',
        fbLink: '#',
        twitterLink: '#',
        behanceLink: '#',
        youtubeLink: '#',
        bio: "Ms. Normandy Klaas is the Sales and Marketing Coordinator, responsible for promoting Testfabrics’ products and managing client relationships to enhance business growth."
    },

    {
        id: uuidv4(),
        img: member5,
        name: 'Mrs. Verlean Winslow',
        position: 'Order Entry Receptionist',
        fbLink: '#',
        twitterLink: '#',
        behanceLink: '#',
        youtubeLink: '#',
        bio: "As the Order Entry Receptionist, Mrs. Verlean Winslow is the first point of contact for customer inquiries, ensuring smooth order processing and excellent customer service."
    },

    {
        id: uuidv4(),
        img: member6,
        name: 'Mr. Brian Freeman',
        position: 'Manager Warehouse and Shipping ',
        fbLink: '#',
        twitterLink: '#',
        behanceLink: '#',
        youtubeLink: '#',
        bio: "Mr. Brian Freeman is the Warehouse and Shipping Manager, overseeing logistics and ensuring timely and accurate order fulfillment."
    },

    {
        id: uuidv4(),
        img: member6,
        name: 'Mr. Tom Gill   ',
        position: 'Manager Production',
        fbLink: '#',
        twitterLink: '#',
        behanceLink: '#',
        youtubeLink: '#',
        bio: "Managing the Elkay Weaving Co. Inc. facility in Wilkes Barre, Pennsylvania, Mr. Tom Gill plays a crucial role in producing multifiber fabrics used in testing protocols worldwide. His leadership at the facility, which has been a part of Testfabrics since 1965, ensures consistent and reliable textile solutions."
    },
];

export default teamData;
